import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import type { UploadProps } from 'antd';
import type { RcFile } from 'antd/es/upload';

interface Props {
  companyName: string;
  disabled: boolean;
  logo: string;
  onRemove: () => void;
  onUploadChange: UploadProps['onChange'];
  validateFile: (file: RcFile) => boolean;
}

const CompanyLogoControl = ({
  companyName,
  disabled,
  logo,
  onRemove,
  onUploadChange,
  validateFile,
}: Props) => {
  const initials =
    companyName
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0])
      .join('')
      .toUpperCase() || 'CO';

  return (
    <div className="company-logo-editor">
      <div className="company-logo-editor__preview">
        {logo ? <img src={logo} alt={`${companyName} logo`} /> : initials}
      </div>
      <div>
        <strong>Company logo</strong>
        <p>PNG or JPG, up to 2 MB. A square image works best.</p>
        <div className="company-logo-editor__actions">
          <Upload
            accept="image/png,image/jpeg"
            beforeUpload={validateFile}
            customRequest={({ onSuccess }) => onSuccess?.({})}
            disabled={disabled}
            name="companyLogo"
            onChange={onUploadChange}
            showUploadList={false}
          >
            <button
              className="company-secondary-action"
              type="button"
              disabled={disabled}
            >
              <UploadOutlined aria-hidden />
              {logo ? 'Change logo' : 'Upload logo'}
            </button>
          </Upload>
          {logo ? (
            <button
              className="company-text-action company-text-action--danger"
              type="button"
              disabled={disabled}
              onClick={onRemove}
            >
              <DeleteOutlined aria-hidden />
              Remove
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CompanyLogoControl;
